import type { FillRule, FillStyle } from '../model/types';

export interface ResolvedFill {
  readonly color: string;
  readonly opacity: number;
  readonly rule: FillRule;
}

/**
 * A fill as output draws it. Unlike a stroke it has no width, so no transform changes it:
 * a filled shape simply scales with its outline (ADR 0016).
 */
export function resolveFill(fill: FillStyle | 'none'): ResolvedFill | null {
  return fill === 'none' ? null : { color: fill.color, opacity: fill.opacity, rule: fill.rule };
}
